import { useEffect, useState } from "react";
import { AntpsicologicosCreate } from "./AntpsicologicosCreate";
import { useLoaderData, useParams } from "react-router-dom";
import Select from "react-select";

import * as APIUSER from "../services/user";

import * as API from "../services/antpsicologicos";

export function AntpsicologicosNew(props) {
  const antpsicologicos = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let antpsicologicosLength = antpsicologicos.length;
  let currentSesion = antpsicologicosLength + 1;

  const [antpsicResp, setAntpsicResp] = useState(props.especialistaFullName);
  const [antpsicFecha, setAntpsicFecha] = useState(todayDate);
  const [antpsicTipo, setAntpsicTipo] = useState("");
  const [antpsicTratprevRad, setAntpsicTratprevRad] = useState("");
  const [antpsicTratPrevRep, setAntpsicTratPrevRep] = useState([
    {
      fechaentrada: "",
      motivosalida: "",
      diaspermanencia: "",
      diasabstinencia: "",
      modalidad: "",
    },
  ]);

  const [antpsicAfam, setAntpsicAfam] = useState("");

  const [antpsicPfamRad, setAntpsicPfamRad] = useState("");
  const [antpsicPfamEsp, setAntpsicPfamEsp] = useState("");
  const [antpsicPsocRad, setAntpsicPsocRad] = useState("");
  const [antpsicPsocEsp, setAntpsicPsocEsp] = useState("");
  const [antpsicPlegRad, setAntpsicPlegRad] = useState("");
  const [antpsicPlegEsp, setAntpsicPlegEsp] = useState("");
  const [antpsicPlabRad, setAntpsicPlabRad] = useState("");
  const [antpsicPlabEsp, setAntpsicPlabEsp] = useState("");
  const [antpsicActtrat, setAntpsicActtrat] = useState("");
  const [antpsicRelinterpfam, setAntpsicRelinterpfam] = useState("");
  const [antpsicRelinterptrab, setAntpsicRelinterptrab] = useState("");
  const [antpsicRelinterpoc, setAntpsicRelinterpoc] = useState("");
  const [antpsicVivadic, setAntpsicVivadic] = useState("");
  const [antpsicFampsiq, setAntpsicFampsiq] = useState("");
  const [antpsicRelpadre, setAntpsicRelpadre] = useState("");
  const [antpsicRelmadre, setAntpsicRelmadre] = useState("");
  const [antpsicRelherm, setAntpsicRelherm] = useState("");
  const [antpsicRelpareja, setAntpsicRelpareja] = useState("");
  const [antpsicRelhij, setAntpsicRelhij] = useState("");
  const [antpsicConvivact, setAntpsicConvivact] = useState("");
  const [antpsicEstciv, setAntpsicEstciv] = useState("");
  const [antpsicManutRad, setAntpsicManutRad] = useState("");
  const [antpsicManutEsp, setAntpsicManutEsp] = useState("");
  const [antpsicExptrabaj, setAntpsicExptrabaj] = useState("");
  const [antpsicTrabaj, setAntpsicTrabaj] = useState("");
  const [antpsicEstlabact, setAntpsicEstlabact] = useState("");
  const [antpsicEduc, setAntpsicEduc] = useState("");
  const [antpsicProfRad, setAntpsicProfRad] = useState("");
  const [antpsicProfEsp, setAntpsicProfEsp] = useState("");
  const [antpsicTrafdrogRad, setAntpsicTrafdrogRad] = useState("");
  const [antpsicTrafdorgEsp, setAntpsicTrafdorgEsp] = useState("");
  const [antpsicJuicRad, setAntpsicJuicRad] = useState("");
  const [antpsicJuicEsp, setAntpsicJuicEsp] = useState("");
  const [antpsicCarcRad, setAntpsicCarcRad] = useState("");
  const [antpsicCarcEsp, setAntpsicCarcEsp] = useState("");
  const [antpsicArrestRad, setAntpsicArrestRad] = useState("");
  const [antpsicArrestEsp, setAntpsicArrestEsp] = useState("");
  const [antpsicSuicRad, setAntpsicSuicRad] = useState("");
  const [antpsicSuicEsp, setAntpsicSuicEsp] = useState("");
  const [antpsicAlucRad, setAntpsicAlucRad] = useState("");
  const [antpsicAlucEsp, setAntpsicAlucEsp] = useState("");
  const [antpsicApanRad, setAntpsicApanRad] = useState("");
  const [antpsicApanEsp, setAntpsicApanEsp] = useState("");
  const [antpsicConvulRad, setAntpsicConvulRad] = useState("");
  const [antpsicConvulEsp, setAntpsicConvulEsp] = useState("");
  const [antpsicPerdconcRad, setAntpsicPerdconcRad] = useState("");
  const [antpsicPerdconcEsp, setAntpsicPerdconcEsp] = useState("");
  const [antpsicAmnlacRad, setAntpsicAmnlacRad] = useState("");
  const [antpsicAmnlacEsp, setAntpsicAmnlacEsp] = useState("");
  const [antpsicPensparanRad, setAntpsicPensparanRad] = useState("");
  const [antpsicPensparanEsp, setAntpsicPensparanEsp] = useState("");
  const [antpsicTratpsicofRad, setAntpsicTratpsicofRad] = useState("");
  const [antpsicTratpsicofEsp, setAntpsicTratpsicofEsp] = useState("");
  const [antpsicTratpsiqRad, setAntpsicTratpsiqRad] = useState("");
  const [antpsicTratpsiqEsp, setAntpsicTratpsiqEsp] = useState("");
  const [antpsicTerapdist, setAntpsicTerapdist] = useState("");
  const [antpsicTerapcolabRad, setAntpsicTerapcolabRad] = useState("");
  const [antpsicAnamnesis, setAntpsicAnamnesis] = useState("");
  const [antpsicEntfamiliar, setAntpsicEntfamiliar] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const antpsicTratPrevRepOpt = [
    { value: "1", label: "Hospitalaria" },
    { value: "2", label: "Ambulatoria" },
    { value: "3", label: "Comunidad terapéutica" },
    { value: "4", label: "Metadona" },
    { value: "5", label: "Antagonistas" },
    { value: "6", label: "Granja" },
    { value: "7", label: "Sin ayuda especializada" },
    { value: "8", label: "Otros" },
  ];

  const handleAntpsicTratPrevRepChange = (event, index) => {
    let data = [...antpsicTratPrevRep];
    console.log(event.target.name);
    data[index][event.target.name] = event.target.value;
    setAntpsicTratPrevRep(data);
  };

  const handleAntpsicTratPrevRepChangeSelect = (event, index) => {
    console.log(event, index);
    let data = [...antpsicTratPrevRep];
    // console.log(event.target.name)
    data[index]["modalidad"] = event;
    setAntpsicTratPrevRep(data);
  };

  const addAntpsicTratPrevRep = (e) => {
    e.preventDefault();
    let object = {
      fechaentrada: "",
      motivosalida: "",
      diaspermanencia: "",
      diasabstinencia: "",
      modalidad: "",
    };

    setAntpsicTratPrevRep([...antpsicTratPrevRep, object]);
  };

  const removeFields = (event, index) => {
    event.preventDefault();
    let data = [...antpsicTratPrevRep];
    data.splice(index, 1);
    setAntpsicTratPrevRep(data);
  };

  console.log(antpsicTratPrevRep);

  useEffect(() => {
    API.getAllAntpsicologicosByTax(tratamientoId)
      .then((response) => {
        // Si la llamada a la API devuelve datos
        if (response && response.length > 0) {
          // Tomar el último elemento de los datos
          const lastItem = response.pop();
          if (lastItem) {
            setAntpsicTipo(lastItem.meta?.antpsicTipo);
            setAntpsicTratprevRad(lastItem.meta?.antpsicTratprevRad);
            setAntpsicTratPrevRep(lastItem.meta?.antpsicTratPrevRep);
            setAntpsicAfam(lastItem.meta?.antpsicAfam);
            setAntpsicPfamRad(lastItem.meta?.antpsicPfamRad);
            setAntpsicPfamEsp(lastItem.meta?.antpsicPfamEsp);
            setAntpsicPsocRad(lastItem.meta?.antpsicPsocRad);
            setAntpsicPsocEsp(lastItem.meta?.antpsicPsocEsp);
            setAntpsicPlegRad(lastItem.meta?.antpsicPlegRad);
            setAntpsicPlegEsp(lastItem.meta?.antpsicPlegEsp);
            setAntpsicPlabRad(lastItem.meta?.antpsicPlabRad);
            setAntpsicPlabEsp(lastItem.meta?.antpsicPlabEsp);
            setAntpsicActtrat(lastItem.meta?.antpsicActtrat);
            setAntpsicRelinterpfam(lastItem.meta?.antpsicRelinterpfam);
            setAntpsicRelinterptrab(lastItem.meta?.antpsicRelinterptrab);
            setAntpsicRelinterpoc(lastItem.meta?.antpsicRelinterpoc);
            setAntpsicVivadic(lastItem.meta?.antpsicVivadic);
            setAntpsicFampsiq(lastItem.meta?.antpsicFampsiq);
            setAntpsicRelpadre(lastItem.meta?.antpsicRelpadre);
            setAntpsicRelmadre(lastItem.meta?.antpsicRelmadre);
            setAntpsicRelherm(lastItem.meta?.antpsicRelherm);
            setAntpsicRelpareja(lastItem.meta?.antpsicRelpareja);
            setAntpsicRelhij(lastItem.meta?.antpsicRelhij);
            setAntpsicConvivact(lastItem.meta?.antpsicConvivact);
            setAntpsicEstciv(lastItem.meta?.antpsicEstciv);
            setAntpsicManutRad(lastItem.meta?.antpsicManutRad);
            setAntpsicManutEsp(lastItem.meta?.antpsicManutEsp);
            setAntpsicExptrabaj(lastItem.meta?.antpsicExptrabaj);
            setAntpsicTrabaj(lastItem.meta?.antpsicTrabaj);
            setAntpsicEstlabact(lastItem.meta?.antpsicEstlabact);
            setAntpsicEduc(lastItem.meta?.antpsicEduc);
            setAntpsicProfRad(lastItem.meta?.antpsicProfRad);
            setAntpsicProfEsp(lastItem.meta?.antpsicProfEsp);
            setAntpsicTrafdrogRad(lastItem.meta?.antpsicTrafdrogRad);
            setAntpsicTrafdorgEsp(lastItem.meta?.antpsicTrafdorgEsp);
            setAntpsicJuicRad(lastItem.meta?.antpsicJuicRad);
            setAntpsicJuicEsp(lastItem.meta?.antpsicJuicEsp);
            setAntpsicCarcRad(lastItem.meta?.antpsicCarcRad);
            setAntpsicCarcEsp(lastItem.meta?.antpsicCarcEsp);
            setAntpsicArrestRad(lastItem.meta?.antpsicArrestRad);
            setAntpsicArrestEsp(lastItem.meta?.antpsicArrestEsp);
            setAntpsicSuicRad(lastItem.meta?.antpsicSuicRad);
            setAntpsicSuicEsp(lastItem.meta?.antpsicSuicEsp);
            setAntpsicAlucRad(lastItem.meta?.antpsicAlucRad);
            setAntpsicAlucEsp(lastItem.meta?.antpsicAlucEsp);
            setAntpsicApanRad(lastItem.meta?.antpsicApanRad);
            setAntpsicApanEsp(lastItem.meta?.antpsicApanEsp);
            setAntpsicConvulRad(lastItem.meta?.antpsicConvulRad);
            setAntpsicConvulEsp(lastItem.meta?.antpsicConvulEsp);
            setAntpsicPerdconcRad(lastItem.meta?.antpsicPerdconcRad);
            setAntpsicPerdconcEsp(lastItem.meta?.antpsicPerdconcEsp);
            setAntpsicAmnlacRad(lastItem.meta?.antpsicAmnlacRad);
            setAntpsicAmnlacEsp(lastItem.meta?.antpsicAmnlacEsp);
            setAntpsicPensparanRad(lastItem.meta?.antpsicPensparanRad);
            setAntpsicPensparanEsp(lastItem.meta?.antpsicPensparanEsp);
            setAntpsicTratpsicofRad(lastItem.meta?.antpsicTratpsicofRad);
            setAntpsicTratpsicofEsp(lastItem.meta?.antpsicTratpsicofEsp);
            setAntpsicTratpsiqRad(lastItem.meta?.antpsicTratpsiqRad);
            setAntpsicTratpsiqEsp(lastItem.meta?.antpsicTratpsiqEsp);
            setAntpsicTerapdist(lastItem.meta?.antpsicTerapdist);
            setAntpsicTerapcolabRad(lastItem.meta?.antpsicTerapcolabRad);
            setAntpsicAnamnesis(lastItem.meta?.antpsicAnamnesis);
            setAntpsicEntfamiliar(lastItem.meta?.antpsicEntfamiliar);
          }
        }
      })
      .catch((error) => console.error(error));
  }, [tratamientoId]);

  const submitAntpsicologicos = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await AntpsicologicosCreate(
        antpsicResp,
        antpsicFecha,
        antpsicTipo,
        antpsicTratprevRad,
        antpsicTratPrevRep,
        antpsicAfam,
        antpsicPfamRad,
        antpsicPfamEsp,
        antpsicPsocRad,
        antpsicPsocEsp,
        antpsicPlegRad,
        antpsicPlegEsp,
        antpsicPlabRad,
        antpsicPlabEsp,
        antpsicActtrat,
        antpsicRelinterpfam,
        antpsicRelinterptrab,
        antpsicRelinterpoc,
        antpsicVivadic,
        antpsicFampsiq,
        antpsicRelpadre,
        antpsicRelmadre,
        antpsicRelherm,
        antpsicRelpareja,
        antpsicRelhij,
        antpsicConvivact,
        antpsicEstciv,
        antpsicManutRad,
        antpsicManutEsp,
        antpsicExptrabaj,
        antpsicTrabaj,
        antpsicEstlabact,
        antpsicEduc,
        antpsicProfRad,
        antpsicProfEsp,
        antpsicTrafdrogRad,
        antpsicTrafdorgEsp,
        antpsicJuicRad,
        antpsicJuicEsp,
        antpsicCarcRad,
        antpsicCarcEsp,
        antpsicArrestRad,
        antpsicArrestEsp,
        antpsicSuicRad,
        antpsicSuicEsp,
        antpsicAlucRad,
        antpsicAlucEsp,
        antpsicApanRad,
        antpsicApanEsp,
        antpsicConvulRad,
        antpsicConvulEsp,
        antpsicPerdconcRad,
        antpsicPerdconcEsp,
        antpsicAmnlacRad,
        antpsicAmnlacEsp,
        antpsicPensparanRad,
        antpsicPensparanEsp,
        antpsicTratpsicofRad,
        antpsicTratpsicofEsp,
        antpsicTratpsiqRad,
        antpsicTratpsiqEsp,
        antpsicTerapdist,
        antpsicTerapcolabRad,
        antpsicAnamnesis,
        antpsicEntfamiliar,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../psicologicos/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        <form id="formNewElement" onSubmit={submitAntpsicologicos}>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="antpsicResp">Responsable</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicResp"
                  required
                  type="text"
                  value={antpsicResp}
                  onChange={(e) => setAntpsicResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicFecha">Fecha visita</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicFecha"
                  required
                  type="date"
                  value={antpsicFecha}
                  onChange={(e) => setAntpsicFecha(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicTipo">Tipo</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicTipo"
                    required
                    name="antpsicTipo"
                    value={antpsicTipo}
                    onChange={(e) => setAntpsicTipo(e.target.value)}
                  >
                    <option disabled value="">
                      {" "}
                      -- Selecciona una opción --
                    </option>
                    <option value="Valoración">Valoración</option>
                    <option value="Ingreso">Ingreso</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <h3>Tratamientos previos</h3>
          <div className="antpsicTratPrevRepContainer">
            <div
              className="field key"
              data-key={antpsicTratprevRad?.toString()}
            >
              <div className="control">
                <label className="radio-title">
                  ¿El paciente ha realizado tratamientos previos?
                </label>
                <label className="radio" htmlFor="antpsicTratprevRadSi">
                  <input
                    id="antpsicTratprevRadSi"
                    name="antpsicTratprevRad"
                    type="radio"
                    value="Si"
                    checked={antpsicTratprevRad === "Si"}
                    onChange={(e) => setAntpsicTratprevRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicTratprevRadNo">
                  <input
                    id="antpsicTratprevRadNo"
                    name="antpsicTratprevRad"
                    type="radio"
                    value="No"
                    checked={antpsicTratprevRad === "No"}
                    onChange={(e) => setAntpsicTratprevRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            {/* aqui empieza el campo repetido */}

            {antpsicTratPrevRep.map((form, index) => {
              return (
                <div className="antpsicTratPrevRepItem lock" key={index}>
                  <div className="grid--2col">
                    <div className="field">
                      <label htmlFor="fechaentrada">Fecha de entrada</label>
                      <div className="control">
                        <input
                          className="input"
                          name="fechaentrada"
                          type="date"
                          value={form.fechaentrada}
                          onChange={(event) =>
                            handleAntpsicTratPrevRepChange(event, index)
                          }
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="motivosalida">Motivo de salida</label>
                      <div className="control">
                        <input
                          className="input"
                          name="motivosalida"
                          type="text"
                          value={form.motivosalida}
                          onChange={(event) =>
                            handleAntpsicTratPrevRepChange(event, index)
                          }
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="diaspermanencia">
                        Tiempo de permanencia (Nº de días)
                      </label>
                      <div className="control">
                        <input
                          className="input"
                          name="diaspermanencia"
                          type="number"
                          value={form.diaspermanencia}
                          onChange={(event) =>
                            handleAntpsicTratPrevRepChange(event, index)
                          }
                        />
                      </div>
                    </div>

                    <div className="field">
                      <label htmlFor="diasabstinencia">
                        Tiempo de abstinencia (Nº de días)
                      </label>
                      <div className="control">
                        <input
                          className="input"
                          name="diasabstinencia"
                          type="number"
                          value={form.diasabstinencia}
                          onChange={(event) =>
                            handleAntpsicTratPrevRepChange(event, index)
                          }
                        />
                      </div>
                    </div>

                    <div className="field">
                      <label htmlFor="modalidad">Modalidad</label>
                      <div className="control">
                        <Select
                          isMulti
                          name="modalidad"
                          options={antpsicTratPrevRepOpt}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Seleccionar modalidad"
                          value={form.modalidad}
                          onChange={(event) =>
                            handleAntpsicTratPrevRepChangeSelect(event, index)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    className="button btn-remove is-danger is-light"
                    onClick={(event) => removeFields(event, index)}
                  >
                    Eliminar tratamiento previo
                  </button>
                </div>
              );
            })}
            <button
              className="lock button btn-add is-success is-light"
              onClick={addAntpsicTratPrevRep}
            >
              Añadir otro tratamiento previo
            </button>

            {/* aqui termina el campo repetido */}
          </div>
          <h3>Situación familiar y social</h3>

          <div className="grid--2col">
            <div className="field">
              <label htmlFor="antpsicEstciv">Estado civil</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicEstciv"
                    required
                    name="antpsicEstciv"
                    value={antpsicEstciv}
                    onChange={(e) => setAntpsicEstciv(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="soltero">Soltero</option>
                    <option value="casado">Casado</option>
                    <option value="separado">Separado</option>
                    <option value="divorciado">Divorciado</option>
                    <option value="viudo">Viudo</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicConvivact">Convivencia actual</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicConvivact"
                    required
                    name="antpsicConvivact"
                    value={antpsicConvivact}
                    onChange={(e) => setAntpsicConvivact(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="solo">Solo</option>
                    <option value="con-padres">Con sus padres</option>
                    <option value="con-pareja">Con su pareja</option>
                    <option value="con-pareja-hijos">
                      Con su pareja e hijos
                    </option>
                    <option value="sin-hogar">Sin hogar</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelpadre">
                En general ¿las relaciones con tu padre son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelpadre"
                    required
                    name="antpsicRelpadre"
                    value={antpsicRelpadre}
                    onChange={(e) => setAntpsicRelpadre(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="buenas">Buenas</option>
                    <option value="regulares">Regulares</option>
                    <option value="malas">Malas</option>
                    <option value="no-relacion">No existe relación</option>
                    <option value="no-existe-fam">
                      No existe dicho familiar
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelmadre">
                En general ¿las relaciones con tu madre son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelmadre"
                    required
                    name="antpsicRelmadre"
                    value={antpsicRelmadre}
                    onChange={(e) => setAntpsicRelmadre(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="buenas">Buenas</option>
                    <option value="regulares">Regulares</option>
                    <option value="malas">Malas</option>
                    <option value="no-relacion">No existe relación</option>
                    <option value="no-existe-fam">
                      No existe dicho familiar
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelherm">
                En general ¿las relaciones con tus hermanos son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelherm"
                    required
                    name="antpsicRelherm"
                    value={antpsicRelherm}
                    onChange={(e) => setAntpsicRelherm(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="buenas">Buenas</option>
                    <option value="regulares">Regulares</option>
                    <option value="malas">Malas</option>
                    <option value="no-relacion">No existe relación</option>
                    <option value="no-existe-fam">
                      No existe dicho familiar
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelpareja">
                En general ¿las relaciones con tu pareja son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelpareja"
                    required
                    name="antpsicRelpareja"
                    value={antpsicRelpareja}
                    onChange={(e) => setAntpsicRelpareja(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="buenas">Buenas</option>
                    <option value="regulares">Regulares</option>
                    <option value="malas">Malas</option>
                    <option value="no-relacion">No existe relación</option>
                    <option value="no-existe-fam">
                      No existe dicho familiar
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelhij">
                En general ¿las relaciones con tus hijos son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelhij"
                    required
                    name="antpsicRelhij"
                    value={antpsicRelhij}
                    onChange={(e) => setAntpsicRelhij(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="buenas">Buenas</option>
                    <option value="regulares">Regulares</option>
                    <option value="malas">Malas</option>
                    <option value="no-relacion">No existe relación</option>
                    <option value="no-existe-fam">
                      No existe dicho familiar
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicFampsiq">
                ¿Alguno de sus familiares ha tenido problemas psiquiátricos o
                relacionados con alcohol, drogas y/o juegos que le hayan llevado
                a tratamiento?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicFampsiq"
                    required
                    name="antpsicFampsiq"
                    value={antpsicFampsiq}
                    onChange={(e) => setAntpsicFampsiq(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="no">No</option>
                    <option value="si-tox">Sí, toxicomanía</option>
                    <option value="si-psiq">Sí, psiquiátricos</option>
                    <option value="no-sabe">No sabe</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicVivadic">
                ¿Vive o ha vivido con alguien que tenga algún tipo de adicción?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicVivadic"
                    required
                    name="antpsicVivadic"
                    value={antpsicVivadic}
                    onChange={(e) => setAntpsicVivadic(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="no">No</option>
                    <option value="si-pasad">Sí, en el pasado</option>
                    <option value="si-act">Sí, en la actualidad</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelinterpfam">
                ¿Sus relaciones interpersonales (Familia) son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelinterpfam"
                    required
                    name="antpsicRelinterpfam"
                    value={antpsicRelinterpfam}
                    onChange={(e) => setAntpsicRelinterpfam(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="no-exist">
                      No existe ese grupo de referencia
                    </option>
                    <option value="no-consum">No consumidores</option>
                    <option value="consum">Consumidores</option>
                    <option value="ex-cosum">Ex-consumidores</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelinterptrab">
                ¿Sus relaciones interpersonales (Trabajo) son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelinterptrab"
                    required
                    name="antpsicRelinterptrab"
                    value={antpsicRelinterptrab}
                    onChange={(e) => setAntpsicRelinterptrab(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="no-exist">
                      No existe ese grupo de referencia
                    </option>
                    <option value="no-consum">No consumidores</option>
                    <option value="consum">Consumidores</option>
                    <option value="ex-cosum">Ex-consumidores</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicRelinterpoc">
                ¿Sus relaciones interpersonales (Ocio) son…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicRelinterpoc"
                    required
                    name="antpsicRelinterpoc"
                    value={antpsicRelinterpoc}
                    onChange={(e) => setAntpsicRelinterpoc(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="no-exist">
                      No existe ese grupo de referencia
                    </option>
                    <option value="no-consum">No consumidores</option>
                    <option value="consum">Consumidores</option>
                    <option value="ex-cosum">Ex-consumidores</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicActtrat">
                ¿El actual tratamiento fue decidido por…?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicActtrat"
                    required
                    name="antpsicActtrat"
                    value={antpsicActtrat}
                    onChange={(e) => setAntpsicActtrat(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="el-mism">El mismo</option>
                    <option value="su-fam-orig">Su familia de origen</option>
                    <option value="su-parej">Su pareja</option>
                    <option value="sist-jud">Sistema judicial</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field key" data-key={antpsicPfamRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido preocupaciones o dificultades familiares en los
                  últimos 30 días?
                </label>
                <label className="radio" htmlFor="antpsicPfamRadSi">
                  <input
                    id="antpsicPfamRadSi"
                    name="antpsicPfamRad"
                    type="radio"
                    value="Si"
                    checked={antpsicPfamRad === "Si"}
                    onChange={(e) => setAntpsicPfamRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicPfamRadNo">
                  <input
                    id="antpsicPfamRadNo"
                    name="antpsicPfamRad"
                    type="radio"
                    value="No"
                    checked={antpsicPfamRad === "No"}
                    onChange={(e) => setAntpsicPfamRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicPfamEsp">
                Especificar dificultades familiares
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicPfamEsp"
                  type="text"
                  value={antpsicPfamEsp}
                  onChange={(e) => setAntpsicPfamEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicPsocRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido preocupaciones o dificultades sociales en los
                  últimos 30 días?
                </label>
                <label className="radio" htmlFor="antpsicPsocRadSi">
                  <input
                    id="antpsicPsocRadSi"
                    name="antpsicPsocRad"
                    type="radio"
                    value="Si"
                    checked={antpsicPsocRad === "Si"}
                    onChange={(e) => setAntpsicPsocRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicPsocRadNo">
                  <input
                    id="antpsicPsocRadNo"
                    name="antpsicPsocRad"
                    type="radio"
                    value="No"
                    checked={antpsicPsocRad === "No"}
                    onChange={(e) => setAntpsicPsocRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicPsocEsp">
                Especificar dificultades sociales
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicPsocEsp"
                  type="text"
                  value={antpsicPsocEsp}
                  onChange={(e) => setAntpsicPsocEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicPlegRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido preocupaciones o dificultades legales en los
                  últimos 30 días?
                </label>
                <label className="radio" htmlFor="antpsicPlegRadSi">
                  <input
                    id="antpsicPlegRadSi"
                    name="antpsicPlegRad"
                    type="radio"
                    value="Si"
                    checked={antpsicPlegRad === "Si"}
                    onChange={(e) => setAntpsicPlegRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicPlegRadNo">
                  <input
                    id="antpsicPlegRadNo"
                    name="antpsicPlegRad"
                    type="radio"
                    value="No"
                    checked={antpsicPlegRad === "No"}
                    onChange={(e) => setAntpsicPlegRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicPlegEsp">
                Especificar dificultades legales
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicPlegEsp"
                  type="text"
                  value={antpsicPlegEsp}
                  onChange={(e) => setAntpsicPlegEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicPlabRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido preocupaciones o dificultades laborales en los
                  últimos 30 días?
                </label>
                <label className="radio" htmlFor="antpsicPlabRadSi">
                  <input
                    id="antpsicPlabRadSi"
                    name="antpsicPlabRad"
                    type="radio"
                    value="Si"
                    checked={antpsicPlabRad === "Si"}
                    onChange={(e) => setAntpsicPlabRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicPlabRadNo">
                  <input
                    id="antpsicPlabRadNo"
                    name="antpsicPlabRad"
                    type="radio"
                    value="No"
                    checked={antpsicPlabRad === "No"}
                    onChange={(e) => setAntpsicPlabRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicPlabEsp">
                Especificar dificultades laborales
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicPlabEsp"
                  type="text"
                  value={antpsicPlabEsp}
                  onChange={(e) => setAntpsicPlabEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicAfam">
                ¿Dispone de apoyo para el tratamiento?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicAfam"
                    required
                    name="antpsicAfam"
                    value={antpsicAfam}
                    onChange={(e) => setAntpsicAfam(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="apoy-fam">Apoyo de familiares</option>
                    <option value="apoy-amig">Apoyo de amigos</option>
                    <option value="apoy-fam-amig">
                      Apoyo de familiares y amigos
                    </option>
                    <option value="no-apoy">No dispone de ningún apoyo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <h3>Situación laboral</h3>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="antpsicEduc">Educación</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicEduc"
                    required
                    name="antpsicEduc"
                    value={antpsicEduc}
                    onChange={(e) => setAntpsicEduc(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="analf">Analfabeto</option>
                    <option value="est-basic">Estudios básicos</option>
                    <option value="egb-eso">EGB/ESO</option>
                    <option value="bup-cou">BUP/COU</option>
                    <option value="fp">FP</option>
                    <option value="diplom">Diplomatura</option>
                    <option value="licenc">Licenciatura</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicExptrabaj">Expectativa de trabajo</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicExptrabaj"
                    required
                    name="antpsicExptrabaj"
                    value={antpsicExptrabaj}
                    onChange={(e) => setAntpsicExptrabaj(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="sin-expt">Sin expectativas</option>
                    <option value="mant-trabj-act">
                      Mantener su trabajo actual
                    </option>
                    <option value="camb-trabj">Cambiar de trabajo</option>
                    <option value="comenz-trabj">Comenzar a trabajar</option>
                    <option value="perm-baja">Permanecer de baja</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicTrabaj">Trabaja</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicTrabaj"
                    required
                    name="antpsicTrabaj"
                    value={antpsicTrabaj}
                    onChange={(e) => setAntpsicTrabaj(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="cuent-ajen">Por cuenta ajena</option>
                    <option value="neg-prop">Negocio propio</option>
                    <option value="neg-fam">Negocio familiar</option>
                    <option value="no-trabj">No tiene trabajo</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label htmlFor="antpsicEstlabact">Estado laboral actual</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicEstlabact"
                    required
                    name="antpsicEstlabact"
                    value={antpsicEstlabact}
                    onChange={(e) => setAntpsicEstlabact(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="fijo">Fijo</option>
                    <option value="temporal">Temporal</option>
                    <option value="en-paro">En paro</option>
                    <option value="baja-incapac">De baja/incapacidad</option>
                    <option value="estudiante">Estudiante</option>
                    <option value="ama-casa">Ama de casa</option>
                    <option value="jubilado">Jubilado</option>
                    <option value="otros">Otros</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="field key" data-key={antpsicProfRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Tiene alguna profesión u oficio?
                </label>
                <label className="radio" htmlFor="antpsicProfRadSi">
                  <input
                    id="antpsicProfRadSi"
                    name="antpsicProfRad"
                    type="radio"
                    value="Si"
                    checked={antpsicProfRad === "Si"}
                    onChange={(e) => setAntpsicProfRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicProfRadNo">
                  <input
                    id="antpsicProfRadNo"
                    name="antpsicProfRad"
                    type="radio"
                    value="No"
                    checked={antpsicProfRad === "No"}
                    onChange={(e) => setAntpsicProfRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicProfEsp">Especificar oficio</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicProfEsp"
                  type="text"
                  value={antpsicProfEsp}
                  onChange={(e) => setAntpsicProfEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicManutRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Contribuye alguien en su manutención?
                </label>
                <label className="radio" htmlFor="antpsicManutRadSi">
                  <input
                    id="antpsicManutRadSi"
                    name="antpsicManutRad"
                    type="radio"
                    value="Si"
                    checked={antpsicManutRad === "Si"}
                    onChange={(e) => setAntpsicManutRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicManutRadNo">
                  <input
                    id="antpsicManutRadNo"
                    name="antpsicManutRad"
                    type="radio"
                    value="No"
                    checked={antpsicManutRad === "No"}
                    onChange={(e) => setAntpsicManutRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicManutEsp">Especificar manutención</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicManutEsp"
                  type="text"
                  value={antpsicManutEsp}
                  onChange={(e) => setAntpsicManutEsp(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Situación legal</h3>
          <div className="grid--2col">
            <div
              className="field key"
              data-key={antpsicTrafdrogRad?.toString()}
            >
              <div className="control">
                <label className="radio-title">¿Ha traficado con drogas?</label>
                <label className="radio" htmlFor="antpsicTrafdrogRadSi">
                  <input
                    id="antpsicTrafdrogRadSi"
                    name="antpsicTrafdrogRad"
                    type="radio"
                    value="Si"
                    checked={antpsicTrafdrogRad === "Si"}
                    onChange={(e) => setAntpsicTrafdrogRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicTrafdrogRadNo">
                  <input
                    id="antpsicTrafdrogRadNo"
                    name="antpsicTrafdrogRad"
                    type="radio"
                    value="No"
                    checked={antpsicTrafdrogRad === "No"}
                    onChange={(e) => setAntpsicTrafdrogRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicTrafdorgEsp">Especificar tráfico</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicTrafdorgEsp"
                  type="text"
                  value={antpsicTrafdorgEsp}
                  onChange={(e) => setAntpsicTrafdorgEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicJuicRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Está actualmente esperando juicio o sentencia?
                </label>
                <label className="radio" htmlFor="antpsicJuicRadSi">
                  <input
                    id="antpsicJuicRadSi"
                    name="antpsicJuicRad"
                    type="radio"
                    value="Si"
                    checked={antpsicJuicRad === "Si"}
                    onChange={(e) => setAntpsicJuicRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicJuicRadNo">
                  <input
                    id="antpsicJuicRadNo"
                    name="antpsicJuicRad"
                    type="radio"
                    value="No"
                    checked={antpsicJuicRad === "No"}
                    onChange={(e) => setAntpsicJuicRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicJuicEsp">Especificar sentencia</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicJuicEsp"
                  type="text"
                  value={antpsicJuicEsp}
                  onChange={(e) => setAntpsicJuicEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicCarcRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha estado alguna vez en la cárcel?
                </label>
                <label className="radio" htmlFor="antpsicCarcRadSi">
                  <input
                    id="antpsicCarcRadSi"
                    name="antpsicCarcRad"
                    type="radio"
                    value="Si"
                    checked={antpsicCarcRad === "Si"}
                    onChange={(e) => setAntpsicCarcRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicCarcRadNo">
                  <input
                    id="antpsicCarcRadNo"
                    name="antpsicCarcRad"
                    type="radio"
                    value="No"
                    checked={antpsicCarcRad === "No"}
                    onChange={(e) => setAntpsicCarcRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicCarcEsp">Especificar cárcel</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicCarcEsp"
                  type="text"
                  value={antpsicCarcEsp}
                  onChange={(e) => setAntpsicCarcEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicArrestRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha sido arrestado y/o acusado alguna vez?
                </label>
                <label className="radio" htmlFor="antpsicArrestRadSi">
                  <input
                    id="antpsicArrestRadSi"
                    name="antpsicArrestRad"
                    type="radio"
                    value="Si"
                    checked={antpsicArrestRad === "Si"}
                    onChange={(e) => setAntpsicArrestRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicArrestRadNo">
                  <input
                    id="antpsicArrestRadNo"
                    name="antpsicArrestRad"
                    type="radio"
                    value="No"
                    checked={antpsicArrestRad === "No"}
                    onChange={(e) => setAntpsicArrestRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicArrestEsp">Especificar arresto</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicArrestEsp"
                  type="text"
                  value={antpsicArrestEsp}
                  onChange={(e) => setAntpsicArrestEsp(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Antecedentes psiquiátricos</h3>
          <div className="grid--2col">
            <div className="field key" data-key={antpsicSuicRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez intentos suicidas?
                </label>
                <label className="radio" htmlFor="antpsicSuicRadSi">
                  <input
                    id="antpsicSuicRadSi"
                    name="antpsicSuicRad"
                    type="radio"
                    value="Si"
                    checked={antpsicSuicRad === "Si"}
                    onChange={(e) => setAntpsicSuicRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicSuicRadNo">
                  <input
                    id="antpsicSuicRadNo"
                    name="antpsicSuicRad"
                    type="radio"
                    value="No"
                    checked={antpsicSuicRad === "No"}
                    onChange={(e) => setAntpsicSuicRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicSuicEsp">
                Especificar intentos suicidas
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicSuicEsp"
                  type="text"
                  value={antpsicSuicEsp}
                  onChange={(e) => setAntpsicSuicEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicAlucRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez alucinaciones?
                </label>
                <label className="radio" htmlFor="antpsicAlucRadSi">
                  <input
                    id="antpsicAlucRadSi"
                    name="antpsicAlucRad"
                    type="radio"
                    value="Si"
                    checked={antpsicAlucRad === "Si"}
                    onChange={(e) => setAntpsicAlucRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicAlucRadNo">
                  <input
                    id="antpsicAlucRadNo"
                    name="antpsicAlucRad"
                    type="radio"
                    value="No"
                    checked={antpsicAlucRad === "No"}
                    onChange={(e) => setAntpsicAlucRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicAlucEsp">Especificar alucinaciones</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicAlucEsp"
                  type="text"
                  value={antpsicAlucEsp}
                  onChange={(e) => setAntpsicAlucEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicApanRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez ataques de pánico?
                </label>
                <label className="radio" htmlFor="antpsicApanRadSi">
                  <input
                    id="antpsicApanRadSi"
                    name="antpsicApanRad"
                    type="radio"
                    value="Si"
                    checked={antpsicApanRad === "Si"}
                    onChange={(e) => setAntpsicApanRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicApanRadNo">
                  <input
                    id="antpsicApanRadNo"
                    name="antpsicApanRad"
                    type="radio"
                    value="No"
                    checked={antpsicApanRad === "No"}
                    onChange={(e) => setAntpsicApanRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicApanEsp">
                Especificar ataques de pánico
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicApanEsp"
                  type="text"
                  value={antpsicApanEsp}
                  onChange={(e) => setAntpsicApanEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicConvulRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez convulsiones?
                </label>
                <label className="radio" htmlFor="antpsicConvulRadSi">
                  <input
                    id="antpsicConvulRadSi"
                    name="antpsicConvulRad"
                    type="radio"
                    value="Si"
                    checked={antpsicConvulRad === "Si"}
                    onChange={(e) => setAntpsicConvulRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicConvulRadNo">
                  <input
                    id="antpsicConvulRadNo"
                    name="antpsicConvulRad"
                    type="radio"
                    value="No"
                    checked={antpsicConvulRad === "No"}
                    onChange={(e) => setAntpsicConvulRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicConvulEsp">Especificar convulsiones</label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicConvulEsp"
                  type="text"
                  value={antpsicConvulEsp}
                  onChange={(e) => setAntpsicConvulEsp(e.target.value)}
                />
              </div>
            </div>
            <div
              className="field key"
              data-key={antpsicPerdconcRad?.toString()}
            >
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez pérdidas de conciencia?
                </label>
                <label className="radio" htmlFor="antpsicPerdconcRadSi">
                  <input
                    id="antpsicPerdconcRadSi"
                    name="antpsicPerdconcRad"
                    type="radio"
                    value="Si"
                    checked={antpsicPerdconcRad === "Si"}
                    onChange={(e) => setAntpsicPerdconcRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicPerdconcRadNo">
                  <input
                    id="antpsicPerdconcRadNo"
                    name="antpsicPerdconcRad"
                    type="radio"
                    value="No"
                    checked={antpsicPerdconcRad === "No"}
                    onChange={(e) => setAntpsicPerdconcRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicPerdconcEsp">
                Especificar pérdidas de conciencia
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicPerdconcEsp"
                  type="text"
                  value={antpsicPerdconcEsp}
                  onChange={(e) => setAntpsicPerdconcEsp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={antpsicAmnlacRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez amnesia lacunar?
                </label>
                <label className="radio" htmlFor="antpsicAmnlacRadSi">
                  <input
                    id="antpsicAmnlacRadSi"
                    name="antpsicAmnlacRad"
                    type="radio"
                    value="Si"
                    checked={antpsicAmnlacRad === "Si"}
                    onChange={(e) => setAntpsicAmnlacRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicAmnlacRadNo">
                  <input
                    id="antpsicAmnlacRadNo"
                    name="antpsicAmnlacRad"
                    type="radio"
                    value="No"
                    checked={antpsicAmnlacRad === "No"}
                    onChange={(e) => setAntpsicAmnlacRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicAmnlacEsp">
                Especificar amnesia lacunar
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicAmnlacEsp"
                  type="text"
                  value={antpsicAmnlacEsp}
                  onChange={(e) => setAntpsicAmnlacEsp(e.target.value)}
                />
              </div>
            </div>
            <div
              className="field key"
              data-key={antpsicPensparanRad?.toString()}
            >
              <div className="control">
                <label className="radio-title">
                  ¿Ha tenido alguna vez pensamiento paranoide?
                </label>
                <label className="radio" htmlFor="antpsicPensparanRadSi">
                  <input
                    id="antpsicPensparanRadSi"
                    name="antpsicPensparanRad"
                    type="radio"
                    value="Si"
                    checked={antpsicPensparanRad === "Si"}
                    onChange={(e) => setAntpsicPensparanRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicPensparanRadNo">
                  <input
                    id="antpsicPensparanRadNo"
                    name="antpsicPensparanRad"
                    type="radio"
                    value="No"
                    checked={antpsicPensparanRad === "No"}
                    onChange={(e) => setAntpsicPensparanRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicPensparanEsp">
                Especificar pensamiento paranoide
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicPensparanEsp"
                  type="text"
                  value={antpsicPensparanEsp}
                  onChange={(e) => setAntpsicPensparanEsp(e.target.value)}
                />
              </div>
            </div>
            <div
              className="field key"
              data-key={antpsicTratpsicofRad?.toString()}
            >
              <div className="control">
                <label className="radio-title">
                  ¿Tiene o ha tenido prescrito tratamiento psicofarmacológico
                  independiente a la adicción?
                </label>
                <label className="radio" htmlFor="antpsicTratpsicofRadSi">
                  <input
                    id="antpsicTratpsicofRadSi"
                    name="antpsicTratpsicofRad"
                    type="radio"
                    value="Si"
                    checked={antpsicTratpsicofRad === "Si"}
                    onChange={(e) => setAntpsicTratpsicofRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicTratpsicofRadNo">
                  <input
                    id="antpsicTratpsicofRadNo"
                    name="antpsicTratpsicofRad"
                    type="radio"
                    value="No"
                    checked={antpsicTratpsicofRad === "No"}
                    onChange={(e) => setAntpsicTratpsicofRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicTratpsicofEsp">
                Especificar tratamiento psicofarmacológico
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicTratpsicofEsp"
                  type="text"
                  value={antpsicTratpsicofEsp}
                  onChange={(e) => setAntpsicTratpsicofEsp(e.target.value)}
                />
              </div>
            </div>
            <div
              className="field key"
              data-key={antpsicTratpsiqRad?.toString()}
            >
              <div className="control">
                <label className="radio-title">
                  ¿Ha estado bajo tratamiento psiquiátrico alguna vez
                  independiente a la adicción?
                </label>
                <label className="radio" htmlFor="antpsicTratpsiqRadSi">
                  <input
                    id="antpsicTratpsiqRadSi"
                    name="antpsicTratpsiqRad"
                    type="radio"
                    value="Si"
                    checked={antpsicTratpsiqRad === "Si"}
                    onChange={(e) => setAntpsicTratpsiqRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicTratpsiqRadNo">
                  <input
                    id="antpsicTratpsiqRadNo"
                    name="antpsicTratpsiqRad"
                    type="radio"
                    value="No"
                    checked={antpsicTratpsiqRad === "No"}
                    onChange={(e) => setAntpsicTratpsiqRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="field lock">
              <label htmlFor="antpsicTratpsiqEsp">
                Especificar tratamiento psiquiátrico
              </label>
              <div className="control">
                <input
                  className="input"
                  id="antpsicTratpsiqEsp"
                  type="text"
                  value={antpsicTratpsiqEsp}
                  onChange={(e) => setAntpsicTratpsiqEsp(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Valoración del terapeuta</h3>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="antpsicTerapdist">
                ¿La anterior información está significativamente distorsionada?
              </label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="antpsicTerapdist"
                    required
                    name="antpsicTerapdist"
                    value={antpsicTerapdist}
                    onChange={(e) => setAntpsicTerapdist(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="no">No</option>
                    <option value="si-falsa">
                      Sí, por falsa declaración del paciente
                    </option>
                    <option value="si-incap">
                      Sí, por incapacidad de comprensión del paciente
                    </option>
                    <option value="si-efect">
                      Sí, por estar bajo los efectos del consumo
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div className="field key">
              <div className="control">
                <label className="radio-title">
                  Durante la entrevista ¿el paciente ha estado colaborador?
                </label>
                <label className="radio" htmlFor="antpsicTerapcolabRadSi">
                  <input
                    id="antpsicTerapcolabRadSi"
                    name="antpsicTerapcolabRad"
                    type="radio"
                    value="Si"
                    checked={antpsicTerapcolabRad === "Si"}
                    onChange={(e) => setAntpsicTerapcolabRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="antpsicTerapcolabRadNo">
                  <input
                    id="antpsicTerapcolabRadNo"
                    name="antpsicTerapcolabRad"
                    type="radio"
                    value="No"
                    checked={antpsicTerapcolabRad === "No"}
                    onChange={(e) => setAntpsicTerapcolabRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
          <div className="field">
            <label className="label-title" htmlFor="antpsicAnamnesis">
              Anamnesis
            </label>
            <div className="control">
              <textarea
                className="textarea"
                name="antpsicAnamnesis"
                id="antpsicAnamnesis"
                value={antpsicAnamnesis}
                onChange={(e) => setAntpsicAnamnesis(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="field">
            <label className="label-title" htmlFor="antpsicEntfamiliar">
              Entrevista familiar
            </label>
            <div className="control">
              <textarea
                className="textarea"
                name="antpsicEntfamiliar"
                id="antpsicEntfamiliar"
                value={antpsicEntfamiliar}
                onChange={(e) => setAntpsicEntfamiliar(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id="actions">
        <button 
        className="button is-link" 
        form="formNewElement" 
        type="submit"
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
